import React from 'react';
import SvgIcon from './SvgIcon';

const CaretUp = props => (
    <SvgIcon viewBox="0 0 25 24" fill="none" {...props}>
        <path
            d="M.872 18.372L11.998 5.797a.5.5 0 01.748 0l11.126 12.575"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

CaretUp.displayName = 'CaretUpIcon';

export default CaretUp;
